module.exports = __webpack_public_path__ + "media/assets/images/flags/fj-3c691ada40e6b7d650ca0b5ecb3555d5.svg";